import React, { useEffect, useRef, useState } from 'react'
import { useCatalogStore } from '../../stores/catalogStore'

// Debounced search input for the catalog. Owns its own local input state
// for responsiveness, flushes to the store + triggers a fetch after 300ms
// of inactivity.
const DEBOUNCE_MS = 300

export default function CatalogSearch() {
  const storedSearch = useCatalogStore((s) => s.filters.search)
  const setSearch    = useCatalogStore((s) => s.setSearch)
  const fetchEntries = useCatalogStore((s) => s.fetchEntries)

  const [local, setLocal] = useState(storedSearch || '')
  const debounceRef = useRef(null)

  // When the store changes externally (e.g. clearAllFilters), sync local.
  useEffect(() => {
    setLocal(storedSearch || '')
  }, [storedSearch])

  useEffect(() => {
    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current)
    }
  }, [])

  const handleChange = (e) => {
    const value = e.target.value
    setLocal(value)

    if (debounceRef.current) clearTimeout(debounceRef.current)
    debounceRef.current = setTimeout(() => {
      setSearch(value)
      fetchEntries()
    }, DEBOUNCE_MS)
  }

  const handleClear = () => {
    if (debounceRef.current) clearTimeout(debounceRef.current)
    setLocal('')
    setSearch('')
    fetchEntries()
  }

  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 text-slate-400">
        <svg className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-4.35-4.35M17 11a6 6 0 11-12 0 6 6 0 0112 0z" />
        </svg>
      </div>
      <input
        type="search"
        value={local}
        onChange={handleChange}
        placeholder="Search the catalog…"
        className="w-full rounded-lg border border-slate-200 bg-white pl-9 pr-9 py-2.5 text-sm text-slate-900 placeholder:text-slate-400 focus:border-accent-500 focus:outline-none focus:ring-1 focus:ring-accent-500"
      />
      {local && (
        <button
          type="button"
          onClick={handleClear}
          aria-label="Clear search"
          className="absolute inset-y-0 right-0 flex items-center pr-3 text-slate-400 hover:text-slate-600"
        >
          <svg className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      )}
    </div>
  )
}
